module.exports = __webpack_public_path__ + "img/knowledge_folder_icon_card.6b72c430.svg";